"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroSlideContentStyled = exports.HeroSlideContentWrapper = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _polished = require("polished");

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n        &:before {\n          color: ", ";\n        }\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n          padding: 30px 30px 40px;\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n          align-self: stretch;\n          background-color: ", ";\n          min-height: 100%;\n\n          ", " {\n            background-color: transparent !important;\n            ", " {\n              width: 100%;\n              min-width: auto;\n              max-width: 384px !important;\n            }\n            ", " {\n              max-width: 375px !important;\n              min-height: 389px;\n            }\n          }\n\n          ", " {\n            min-height: auto;\n          }\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        left: -5px;\n        top: -30px;\n        width: calc(100% - 60px);\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  align-self: center;\n  display: flex;\n  position: relative;\n  text-align: ", ";\n  justify-content: center;\n  width: 50%;\n  z-index: 1;\n\n  ", "\n\n  ", " {\n    left: 0;\n    padding: 0;\n    width: 100%;\n\n    ", "\n  }\n\n  ", ";\n\n  ", " {\n    ", "\n    ", "\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color: ", ";\n  padding: 27px 45px;\n  position: relative;\n  width: 495px;\n  min-height: 400px;\n\n  ", " {\n    padding: 30px;\n    width: 329px;\n    min-width: 329px;\n    min-height: 450px;\n  }\n\n  ", " {\n    padding: 30px 24px;\n    max-width: 317px;\n    min-width: 317px;\n    width: 100%;\n    min-height: 409px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  &:before {\n    background-color: currentColor;\n    content: '';\n    height: 100%;\n    left: 10px;\n    position: absolute;\n    top: 10px;\n    width: 100%;\n    z-index: -1;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 570px;\n  max-width: 570px;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var fifityfiftyStyles = (0, _uiKit.css)(_templateObject());
var colorblockStyles = (0, _uiKit.css)(_templateObject2());
var HeroSlideContentWrapper = (0, _uiKit.styled)("div")(_templateObject3(), _uiKit.Colors.secondaryLight, _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaDown.sm);
exports.HeroSlideContentWrapper = HeroSlideContentWrapper;
var HeroSlideContentStyled = (0, _uiKit.styled)("div")(_templateObject4(), function (_ref) {
  var textAlign = _ref.textAlign;
  return textAlign;
}, function (_ref2) {
  var textColor = _ref2.textColor;
  return textColor && (0, _uiKit.css)(_templateObject5(), _uiKit.Colors[textColor]);
}, _uiKit.GridBreakpointsMediaDown.sm, function (_ref3) {
  var type = _ref3.type;
  return type === 'type_block' && (0, _uiKit.css)(_templateObject6());
}, function (_ref4) {
  var type = _ref4.type,
      textBackgroundColor = _ref4.textBackgroundColor;
  return type !== 'type_block' ? (0, _uiKit.css)(_templateObject7(), textBackgroundColor ? _uiKit.Colors[textBackgroundColor] : _uiKit.Colors.secondaryLight, HeroSlideContentWrapper, _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaDown.sm, _uiKit.GridBreakpointsMediaDown.sm) : (0, _uiKit.css)(_templateObject8());
}, HeroSlideContentWrapper, function (_ref5) {
  var type = _ref5.type;
  return type === 'type_block' ? colorblockStyles : fifityfiftyStyles;
}, function (_ref6) {
  var textBackgroundColor = _ref6.textBackgroundColor;
  return textBackgroundColor && (0, _uiKit.css)(_templateObject9(), _uiKit.Colors[textBackgroundColor], (0, _polished.darken)(0.045, _uiKit.Colors[textBackgroundColor]));
});
exports.HeroSlideContentStyled = HeroSlideContentStyled;